import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";
import userStorage from "store/UserStorage";
import { batch } from "react-redux";
import { MetaDataMetasAdminState } from "./types";
import { setResponseMessage } from "../adminSlice";

const initialState: MetaDataMetasAdminState = {
  options: [],
  metas: [],
  meta: undefined,
  loading: false,
  pageMeta: undefined,
};

const metasAdmin = createSlice({
  name: "metasAdminSlice",
  initialState,
  reducers: {
    setMetaForEdit(state, action) {
      state.meta = action.payload;
      state.loading = false;
    },
    setOptions(state, action) {
      state.options = action.payload;
      state.loading = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setMetas(state, action) {
      state.metas = action.payload;
    },
    setPegaMetas(state, action) {
      state.pageMeta = action.payload;
    },
  },
});
export const { setLoading, setOptions, setMetas, setMetaForEdit, setPegaMetas } = metasAdmin.actions;

export const selectLoading = (state: RootState) => state.metasAdmin.loading;

export const selectAllMetas = (state: RootState) => state.metasAdmin.metas;

export const selectMetaForEditing = (state: RootState) => state.metasAdmin.meta;
export const selectMetaForPage = (state: RootState) => state.metasAdmin.pageMeta;

export const fetchAllMetas = () => async (dispatch: any) => {
  try {
    const result = await axios.get(`${API_URL}/admin/metas`);
    dispatch(setMetas(result.data.data));
  } catch (error: any) {
    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};

export const fetchMetasByAlias = (alias: string) => async (dispatch: any) => {
  try {
    const result = await axios.get(`${API_URL}/admin/metas/${alias}`);
    dispatch(setPegaMetas(result.data.data));
  } catch (error: any) {
    console.log(`Error in fetchAllTags: ${error.message}`);
  }
};
export const addMeta = (data: any, onUploadProgress: (e: ProgressEvent<EventTarget>) => void) => async (
  dispatch: any
) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data);
    let token = userStorage.getUser();
    const response = await axios.post(
      `${API_URL}/admin/metas`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно качихте коментара.",
          hasError: false,
        })
      );
      dispatch(setLoading(false));
      dispatch(fetchAllMetas());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });

    //  console.log(`Error in addTag: ${error.message}`);
  }
};

export const updateMeta = (data: any, onUploadProgress: (e: ProgressEvent<EventTarget>) => void) => async (
  dispatch: any
) => {
  try {
    dispatch(setLoading(true));
    const json = JSON.stringify(data.data);
    let token = userStorage.getUser();
    const response = await axios.put(
      `${API_URL}/admin/metas/${data.id}`,
      { data: json },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        onUploadProgress,
      }
    );
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно променихте коментара.",
          hasError: false,
        })
      );
      dispatch(fetchAllMetas());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
    //  console.log(`Error in addProduct: ${error.message}`);
  }
};

export const deleteMeta = (id: string) => async (dispatch: any) => {
  try {
    let token = userStorage.getUser();
    const response = await axios.delete(`${API_URL}/admin/metas/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    batch(() => {
      dispatch(
        setResponseMessage({
          message: "Успешно изтрихте коментара.",
          hasError: false,
        })
      );
      dispatch(fetchAllMetas());
    });
  } catch (error: any) {
    batch(() => {
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
      dispatch(setLoading(false));
    });
    //  console.log(`Error in deleteProduct: ${error.message}`);
  }
};

export const fetchMeta = (id: string) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));

    let token = userStorage.getUser();
    const result = await axios.get(`${API_URL}/admin/meta-values/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(setMetaForEdit(result.data.data));
  } catch (error: any) {
    batch(() => {
      dispatch(setLoading(false));
      dispatch(setResponseMessage({ message: error.message, hasError: true }));
    });

    //  console.log(`Error in editProduct: ${error.message}`);
  }
};

export default metasAdmin.reducer;
